
<div class="d-flex flex-column gap-3">
    <div class="dashboard_header">
        <div class="custom_select">
            <div class="custom_select-header" (click)="toggleDropdown($event)">
                <div>{{ selectedText }}</div>
                <div class="custom_select-icon">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24"
                        height="24" viewBox="0 0 24 24" fill="none">
                        <path d="M6 9L12 15L18 9" stroke="#0A0A0A"
                            stroke-width="2" stroke-linecap="round"
                            stroke-linejoin="round" />
                    </svg>
                </div>
            </div>
            <ul class="custom_select-content" style="display: none;">
                
                <li *ngFor="let option of dateOptions"
                    class="custom_select-item d-flex align-items-center justify-content-between"
                    (click)="selectItem($event, option)">
                    <span>{{ option.label }}</span>
                    <span>{{ option.range }}</span>
                </li>
                <li
                    class="custom_select-item d-flex align-items-center justify-content-between"
                    (click)="selectItem($event, null); openDataPicker()">
                    <span i18n="@@dashboard.custom_range">Custom range</span>
                    <span>
                        <svg xmlns="http://www.w3.org/2000/svg" width="20"
                            height="20" viewBox="0 0 20 20" fill="none">
                            <path d="M7.5 15L12.5 10L7.5 5" stroke="#393939"
                                stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round" />
                        </svg>
                    </span>
                </li>
            </ul>
            <div id="custom_datepicker-popup"
                class="custom_datepicker-popup hidden">
                <div class="d-flex align-items-center gap-2 mb-3">
                    <span i18n="@@dashboard.from">from</span> <input #startDayInput id="start_day_input" type="text"
                        placeholder="Start date" readonly>
                        <span i18n="@@dashboard.to">to</span><input #endDayInput id="end_day_input" type="text"
                        placeholder="End date" readonly>
                </div>
                <div class="custom_datepicker-header">
                    <span id="month-year">{{ monthNames[currentDate.getMonth()]
                        }} {{ currentDate.getFullYear() }}</span>
                    <div class="d-flex align-items-center gap-2">
                        <div
                            (click)="currentDate.setMonth(currentDate.getMonth() - 1); updateCalendar();">
                            <svg xmlns="http://www.w3.org/2000/svg" width="26"
                                height="26" viewBox="0 0 26 26" fill="none">
                                <path
                                    d="M21.6988 15.6736L13.5725 7.54729C13.4184 7.39469 13.2103 7.30908 12.9935 7.30908C12.7766 7.30908 12.5685 7.39469 12.4145 7.54729L4.28814 15.6736C4.1779 15.7911 4.10318 15.9374 4.07262 16.0956C4.04206 16.2538 4.05691 16.4174 4.11546 16.5675C4.17763 16.7154 4.28218 16.8416 4.41595 16.9302C4.54972 17.0187 4.70671 17.0657 4.86714 17.0652H21.1198C21.2802 17.0657 21.4372 17.0187 21.571 16.9302C21.7048 16.8416 21.8093 16.7154 21.8715 16.5675C21.93 16.4174 21.9449 16.2538 21.9143 16.0956C21.8838 15.9374 21.809 15.7911 21.6988 15.6736Z"
                                    fill="#222222" />
                            </svg>
                        </div>
                        <div
                            (click)="currentDate.setMonth(currentDate.getMonth() + 1); updateCalendar();">
                            <svg xmlns="http://www.w3.org/2000/svg" width="26"
                                height="26" viewBox="0 0 26 26" fill="none">
                                <path
                                    d="M21.8759 9.43671C21.8137 9.28881 21.7092 9.16262 21.5754 9.07404C21.4416 8.98547 21.2846 8.93847 21.1242 8.93897H4.87154C4.7111 8.93847 4.55411 8.98547 4.42034 9.07404C4.28658 9.16262 4.18202 9.28881 4.11985 9.43671C4.06131 9.58681 4.04645 9.75042 4.07701 9.90861C4.10757 10.0668 4.1823 10.2131 4.29254 10.3306L12.4189 18.4569C12.5742 18.6071 12.7818 18.6911 12.9979 18.6911C13.2139 18.6911 13.4215 18.6071 13.5769 18.4569L21.7032 10.3306C21.8134 10.2131 21.8882 10.0668 21.9187 9.90861C21.9493 9.75042 21.9344 9.58681 21.8759 9.43671Z"
                                    fill="#222222" />
                            </svg>
                        </div>
                    </div>
                </div>
                <div class="custom_datepicker-days">
                    <span>Su</span><span>Mo</span><span>Tu</span><span>We</span><span>Th</span><span>Fr</span><span>Sa</span>
                </div>
                <div class="custom_datepicker-grid" #datepickerGrid></div>
                <div class="custom_datepicker-footer">
                    <button (click)="cancelDataPicker()"
                        class="secondary_btn w-100"
                        style="height: 40px;">Cancel</button>
                    <button (click)="applyDateRange()" class="primary_btn w-100"
                        style="height: 40px;">Apply</button>
                </div>
            </div>
        </div>
    </div>

    <ul class="invoices_list">

        <li class="invoice_item active">
            <h3 i18n="@@dashboard.total_earnings">Total Earnings</h3>
            <div class="period_list-wrapper">
                <div class="period_list-content">
                    <img style="width: 30px;" loading="lazy" src='/images/icons/sar_symbol_black.svg'> {{ cardDetails.total_earnings }} 
                </div>
                <!-- <div class="percentage_badge_block">
                    <div class="percentage_badge">
                        <svg xmlns="http://www.w3.org/2000/svg" width="14"
                            height="14" viewBox="0 0 14 14" fill="none">
                            <path d="M10.5408 8.41748L7 11.9583L3.45917 8.41748"
                                stroke="#FF0000" stroke-width="1.5"
                                stroke-miterlimit="10" stroke-linecap="round"
                                stroke-linejoin="round" />
                            <path d="M7 2.04175V11.8592" stroke="#FF0000"
                                stroke-width="1.5" stroke-miterlimit="10"
                                stroke-linecap="round"
                                stroke-linejoin="round" />
                        </svg>
                        -30%
                    </div>
                    since yesterday
                </div> -->
            </div>
        </li>
        <li class="invoice_item">
            <h3 i18n="@@dashboard.clients">Clients</h3>
            <div class="period_list-wrapper">
                <div class="period_list-content">
                    {{ cardDetails.clients }}
                </div>
            </div>
        </li>
        <li class="invoice_item">
            <h3 i18n="@@dashboard.orders">Orders</h3>
            <div class="period_list-wrapper">
                <div class="period_list-content">
                    {{ cardDetails.orders }}
                </div>
            </div>
        </li>
        <li class="invoice_item">
            <h3 i18n="@@dashboard.total_expenses">Total Expenses</h3>
            <div class="period_list-wrapper">
                <div class="period_list-content">
                    <img  style="width: 30px;" loading="lazy" src='/images/icons/sar_symbol_black.svg'> {{ cardDetails.expenses }}
                </div>
                <!-- <div class="percentage_badge_block">
                    <div class="percentage_badge positive">
                        <svg xmlns="http://www.w3.org/2000/svg" width="14"
                            height="14" viewBox="0 0 14 14" fill="none">
                            <path
                                d="M3.45923 5.58252L7.00006 2.04169L10.5409 5.58252"
                                stroke="#00AD0C" stroke-width="1.5"
                                stroke-miterlimit="10" stroke-linecap="round"
                                stroke-linejoin="round" />
                            <path d="M7 11.9583L7 2.14075" stroke="#00AD0C"
                                stroke-width="1.5" stroke-miterlimit="10"
                                stroke-linecap="round"
                                stroke-linejoin="round" />
                        </svg>
                        +24%
                    </div>
                    since yesterday
                </div> -->
            </div>
        </li>

    </ul>
</div>
<div class="line_chart_container d-flex flex-column gap-3">
    <div class="line_chart_header">
        <span>SAR</span>
        <span i18n="@@dashboard.client_orders">Clients/Orders</span>
    </div>
    
    <ng-container *ngIf="chartMonth?.length">
        <app-chart [months]="chartMonth" [datasets]="chartData"></app-chart>
    </ng-container>
    
    <div class="line_chart_footer">
        <span>
            <svg xmlns="http://www.w3.org/2000/svg" width="10" height="11"
                viewBox="0 0 10 11" fill="none">
                <circle cx="5" cy="5.5" r="5" fill="#1AACD9" />
            </svg>
            <span i18n="@@dashboard.total_earnings">Total Earnings</span>
        </span>
        <span>
            <svg xmlns="http://www.w3.org/2000/svg" width="10" height="11"
                viewBox="0 0 10 11" fill="none">
                <circle cx="5" cy="5.5" r="5" fill="#EB1461" />
            </svg>
            <span i18n="@@dashboard.clients">Clients</span>
        </span>
        <span>
            <svg xmlns="http://www.w3.org/2000/svg" width="10" height="11"
                viewBox="0 0 10 11" fill="none">
                <circle cx="5" cy="5.5" r="5" fill="#FCCF0B" />
            </svg>
            <span i18n="@@dashboard.orders">Orders</span>
        </span>
        <span>
            <svg xmlns="http://www.w3.org/2000/svg" width="10" height="11"
                viewBox="0 0 10 11" fill="none">
                <circle cx="5" cy="5.5" r="5" fill="#18F121" />
            </svg>
            <span i18n="@@dashboard.total_expenses">Total Expenses</span>
        </span>
    </div>
</div>
